import {
  createTheme,
  PaletteColorOptions,
  PaletteColor,
} from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface PaletteOptions {
    artisticPrimary100: PaletteColorOptions;
    artisticTag: PaletteColorOptions;
    betaTextHigh: PaletteColorOptions;
    artisticStructural200: PaletteColorOptions;
    artisticSuccess500: PaletteColorOptions;
    artisticGrey300: PaletteColorOptions;
    artisticTextHigh: PaletteColorOptions;
    artisticTextMedium: PaletteColorOptions;
    artisticTextLow: PaletteColorOptions;
    artisticTextInteractive: PaletteColorOptions;
    artisticGrey100: PaletteColorOptions;
    artisticAlert300: PaletteColorOptions;
    artisticStructuralTheme: PaletteColorOptions;
    artisticStructural50: PaletteColorOptions;
    artisticStructural100: PaletteColorOptions;
    artisticStructural0: PaletteColorOptions;
    artisticStroke200: PaletteColorOptions;
    artisticStrokeGrey100: PaletteColorOptions;
    artisticStructural300: PaletteColorOptions;
    artisticGrey400: PaletteColorOptions;
    artisticStroke100: PaletteColorOptions;
    classicGrey100: PaletteColorOptions;
    classicStroke200: PaletteColorOptions;
    classicAlert300: PaletteColorOptions;
    classicGrey300: PaletteColorOptions;
    classicSuccess500: PaletteColorOptions;
    classicProgress500: PaletteColorOptions;
    classicAlert500: PaletteColorOptions;
    classicSuccess300: PaletteColorOptions;
    classicProgress300: PaletteColorOptions;
    approved: PaletteColorOptions;
    artisticWarning500: PaletteColorOptions;
    artisticWarning300: PaletteColorOptions;
    artisticGrey500: PaletteColorOptions;
    artisticTags50: PaletteColorOptions;
    artisticTagsGreen50: PaletteColorOptions;
    artisticTagsGreen500: PaletteColorOptions;
    artisticTagsPlum500: PaletteColorOptions;
    artisticTagsPlum50: PaletteColorOptions;
    artisticTagsBlue500: PaletteColorOptions;
    artisticTagsBlue50: PaletteColorOptions;
    iconsPrimary: PaletteColorOptions;
    iconsSecondary: PaletteColorOptions;
    backgroundPrimary: PaletteColorOptions;
    accent: PaletteColorOptions;
    bodyBackground: PaletteColorOptions;
    highlight: PaletteColorOptions;
    gradientBackground: PaletteColorOptions;
    safari50: PaletteColorOptions;
  }

  interface Palette {
    artisticPrimary100: PaletteColor;
    artisticTag: PaletteColor;
    betaTextHigh: PaletteColor;
    artisticStructural200: PaletteColor;
    artisticSuccess500: PaletteColor;
    artisticGrey300: PaletteColor;
    artisticTextHigh: PaletteColor;
    artisticTextMedium: PaletteColor;
    artisticTextLow: PaletteColor;
    artisticTextInteractive: PaletteColor;
    artisticGrey100: PaletteColor;
    artisticAlert300: PaletteColor;
    artisticStructuralTheme: PaletteColor;
    artisticStructural50: PaletteColor;
    artisticStructural100: PaletteColor;
    artisticStructural0: PaletteColor;
    artisticStroke200: PaletteColor;
    artisticStrokeGrey100: PaletteColor;
    artisticStructural300: PaletteColor;
    artisticGrey400: PaletteColor;
    artisticStroke100: PaletteColor;
    classicGrey100: PaletteColor;
    classicStroke200: PaletteColor;
    classicAlert300: PaletteColor;
    classicGrey300: PaletteColor;
    classicSuccess500: PaletteColor;
    classicProgress500: PaletteColor;
    classicAlert500: PaletteColor;
    classicSuccess300: PaletteColor;
    classicProgress300: PaletteColor;
    approved: PaletteColor;
    artisticWarning500: PaletteColor;
    artisticWarning300: PaletteColor;
    artisticGrey500: PaletteColor;
    artisticTags50: PaletteColor;
    artisticTagsGreen50: PaletteColor;
    artisticTagsGreen500: PaletteColor;
    artisticTagsPlum500: PaletteColor;
    artisticTagsPlum50: PaletteColor;
    artisticTagsBlue500: PaletteColor;
    artisticTagsBlue50: PaletteColor;
    iconsPrimary: PaletteColor;
    iconsSecondary: PaletteColor;
    PaletteColorOptions: PaletteColor;
    accent: PaletteColor;
    bodyBackground: PaletteColor;
    highlight: PaletteColor;
    gradientBackground: PaletteColor;
    backgroundPrimary: PaletteColor;
    safari50: PaletteColorOptions;
  }

  interface TypographyVariants {
    caption1: React.CSSProperties;
    caption2: React.CSSProperties;
    body2: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    caption1?: React.CSSProperties;
    caption2?: React.CSSProperties;
    body2?: React.CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    caption1: true;
    caption2: true;
    body2: true;
  }
}

declare module "@mui/lab/TabList" {
  interface TabPropsColorOverrides {
    artisticPrimary100: true;
    artisticTag: true;
    betaTextHigh: true;
    artisticStructural200: true;
    artisticSuccess500: true;
    artisticGrey300: true;
    artisticTextHigh: true;
    artisticTextMedium: true;
    artisticTextLow: true;
    artisticTextInteractive: true;
    artisticGrey100: true;
    artisticAlert300: true;
    artisticStructuralTheme: true;
    artisticStructural50: true;
    artisticStructural100: true;
    artisticStructural0: true;
    artisticStroke200: true;
    artisticStrokeGrey100: true;
    artisticStructural300: true;
    artisticGrey400: true;
    artisticStroke100: true;
    classicGrey100: true;
    classicStroke200: true;
    classicAlert300: true;
    classicGrey300: true;
    classicSuccess500: true;
    classicProgress500: true;
    classicAlert500: true;
    classicSuccess300: true;
    classicProgress300: true;
    approved: true;
    artisticWarning500: true;
    artisticWarning300: true;
    artisticTags50: true;
    artisticTagsGreen50: true;
    artisticTagsGreen500: true;
    artisticTagsPlum500: true;
    artisticTagsPlum50: true;
    artisticTagsBlue500: true;
    artisticTagsBlue50: true;
  }
}

declare module "@mui/material/Fab" {
  interface FabPropsColorOverrides {
    artisticPrimary100: true;
    artisticTag: true;
    betaTextHigh: true;
    artisticStructural200: true;
    artisticSuccess500: true;
    artisticGrey300: true;
    artisticTextHigh: true;
    artisticTextMedium: true;
    artisticTextLow: true;
    artisticTextInteractive: true;
    artisticGrey100: true;
    artisticAlert300: true;
    artisticStructuralTheme: true;
    artisticStructural50: true;
    artisticStructural100: true;
    artisticStructural0: true;
    artisticStroke200: true;
    artisticStrokeGrey100: true;
    artisticStructural300: true;
    artisticGrey400: true;
    artisticStroke100: true;
    classicGrey100: true;
    classicStroke200: true;
    classicAlert300: true;
    classicGrey300: true;
    classicSuccess500: true;
    classicProgress500: true;
    classicAlert500: true;
    classicSuccess300: true;
    classicProgress300: true;
    approved: true;
    artisticWarning500: true;
    artisticWarning300: true;
    artisticTags50: true;
    artisticTagsGreen50: true;
    artisticTagsPlum500: true;
    artisticTagsPlum50: true;
  }
}
declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    artisticPrimary100: true;
    artisticTag: true;
    betaTextHigh: true;
    artisticStructural200: true;
    artisticSuccess500: true;
    artisticGrey300: true;
    artisticTextHigh: true;
    artisticTextMedium: true;
    artisticTextLow: true;
    artisticTextInteractive: true;
    artisticGrey100: true;
    artisticAlert300: true;
    artisticStructuralTheme: true;
    artisticStructural50: true;
    artisticStructural100: true;
    artisticStructural0: true;
    artisticStroke200: true;
    artisticStrokeGrey100: true;
    artisticStructural300: true;
    artisticGrey400: true;
    artisticStroke100: true;
    classicGrey100: true;
    classicStroke200: true;
    classicAlert300: true;
    classicGrey300: true;
    classicSuccess500: true;
    classicProgress500: true;
    classicAlert500: true;
    classicSuccess300: true;
    classicProgress300: true;
    approved: true;
    artisticWarning500: true;
    artisticWarning300: true;
    artisticTags50: true;
    artisticTagsGreen50: true;
  }
}

const theme = createTheme({
  // spacing: [4, 8, 16, 24, 32, 40, 48, 54],
  palette: {
    primary: {
      main: "#E5927D",
    },
    secondary: {
      main: "#19857b",
    },
    artisticPrimary100: {
      main: "#E5927D",
    },
    artisticTag: {
      main: "#EDEEF7",
    },
    betaTextHigh: {
      main: "#344563",
    },
    artisticStructural200: {
      main: "#F0FBFF",
    },
    artisticSuccess500: {
      main: "#42A45C",
    },
    artisticGrey300: {
      main: "#8CB4C2",
    },
    artisticTextHigh: {
      main: "#203D48",
    },
    artisticTextMedium: {
      main: "#7498A6",
    },
    artisticTextLow: {
      main: "#B0CCD6",
    },
    artisticTextInteractive: {
      main: "#C37C6A",
    },
    artisticGrey100: {
      main: "#D1F3FF",
    },
    artisticAlert300: {
      main: "#FFCCCC",
    },
    artisticStructuralTheme: {
      main: "#203D48",
    },
    artisticStructural50: {
      main: "#FCFEFF",
    },
    artisticStructural100: {
      main: "#F7FDFF",
    },
    artisticStructural0: {
      main: "#FFFFFF",
    },
    artisticStroke200: {
      main: "#A9D5E5",
    },
    artisticStrokeGrey100: {
      main: "#D1F3FF",
    },
    artisticTags50: {
      main: "#EDF4F7",
    },
    artisticTagsGreen50: {
      main: "#E0FCF0",
    },
    artisticTagsGreen500: {
      main: "#26835B",
    },
    artisticTagsPlum500: {
      main: "#875882",
    },
    artisticTagsPlum50: {
      main: "#F3EAF2",
    },
    artisticTagsBlue500: {
      main: "#186AE1",
    },
    artisticTagsBlue50: {
      main: "#EAF2FF",
    },
    artisticStructural300: {
      main: "#F2F8FA",
    },
    artisticGrey400: {
      main: "#6B8D99",
    },
    artisticStroke100: {
      main: "#D1F3FF",
    },
    classicGrey100: {
      main: "#E5EAFF",
    },
    classicStroke200: {
      main: "#ACB7E5",
    },
    classicAlert300: {
      main: "#FFCCCC",
    },
    classicGrey300: {
      main: "#919BC2",
    },
    classicSuccess500: {
      main: "#44A45F",
    },
    classicProgress500: {
      main: "#4169E1",
    },
    classicAlert500: {
      main: "#E50000",
    },
    classicSuccess300: {
      main: "#CCFFDA",
    },
    classicProgress300: {
      main: "#E0E8FF",
    },
    approved: {
      main: "#9c5a99",
    },
    artisticWarning500: {
      main: "#F5A73F",
    },
    artisticWarning300: {
      main: "#FFE9CC",
    },
    artisticGrey500: {
      main: "#283B42",
    },
    iconsPrimary: {
      main: "#00008B",
    },
    iconsSecondary: {
      main: "#008080",
    },
    backgroundPrimary: {
      main: "white",
    },
    accent: {
      main: "#00008B",
    },
    bodyBackground: {
      main: "#D3D3D3",
    },
    highlight: {
      main: "#00FFFF",
    },
    safari50: {
      main: "#FFF2EF",
    },
    gradientBackground: {
      main: "linear-gradient(to right,#1D5D9E, #2D93AC,#3DC6B8)",
    },
  },
  typography: {
    button: {
      textTransform: "none",
    },
    fontFamily: "Roboto",
    h1: {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "29.03",
      lineHeight: "34px",
      textTransform: "none",
    },
    h2: {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "24.19px",
      lineHeight: "28px",
      textTransform: "none",
    },
    h3: {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "20.16px",
      lineHeight: "24px",
      textTransform: "none",
    },
    h4: {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "16.8px",
      lineHeight: "20px",
      textTransform: "none",
    },
    subtitle1: {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "16px",
      textTransform: "none",
    },
    subtitle2: {
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "11.67px",
      lineHeight: "14px",
      textTransform: "none",
    },
    body1: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "16px",
      textTransform: "none",
    },
    caption1: {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "11.67px",
      lineHeight: "14px",
      textTransform: "none",
    },
    caption2: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "11.67px",
      lineHeight: "14px",
      textTransform: "none",
    },
    overline: {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "9.72px",
      lineHeight: "12px",
      textTransform: "none",
    },
    body2: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "16px",
      textTransform: "none",
    },
  },

  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          padding: "6px 32px",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&::placeholder": {
            color: "#B0CCD6",
            fontSize: "14px",
            lineHeight: "16px",
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: "#42A45C",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          color: "white",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "&:hover fieldset": {
              border: `1px solid #6B8D99`,
            },
            "&.Mui-focused fieldset": {
              border: `1px solid #6B8D99`,
            },
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarColor: "#6B8D99",
          "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
            borderRadius: "6px",
            width: "12px",
            backgroundColor: "transparent",
            border: "3px solid rgba(0,0,0,0)",
          },
          "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
            backgroundColor: "hsla(0,0%,0%,0.35)",
            backgroundClip: "padding-box",
            border: "3px solid rgba(0,0,0,0)",
            borderRadius: "6px",
            minHeight: "36px",
          },
        },
      },
    },
  },
});

export const scrollStyles = (
  width?: number,
  bgColor?: string,
  borderRadius?: string
) => {
  return {
    scrollBar: {
      "&::-webkit-scrollbar": {
        width: width ?? 6,
        opacity: 1,
        zIndex: 2,
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: bgColor ?? "#afb3b0",
        borderRadius: borderRadius ?? "7px",
      },
    },
  };
};

export default theme;
